import Option from '@/components/form/types/Option.ts';
import { TransportOffering } from '@/features/dashboard/tourTransport/types/TransportOffering.ts';

export const transportOfferingLabels: Record<TransportOffering, string> = {
  [TransportOffering.OFFERS_TRANSPORT]: 'Oferuję transport',
  [TransportOffering.NO_TRANSPORT]: 'Bez transportu',
};

export const getTransportOfferingLabel = (offering: string): string =>
  transportOfferingLabels[offering as TransportOffering] ?? offering;

export const transportOfferingToggleOptions: Option[] = Object.values(
  TransportOffering,
).map((value) => ({
  value,
  label: transportOfferingLabels[value],
}));
